import { useRef, useState } from "react";
import { useClickAway } from "ahooks";
import cls from "classnames";
import { observer } from "mobx-react";
import { Tooltip, Popover, Modal } from "antd";
import {
  ISessionFile,
  ESessionFileType,
  ESessionFileContentParseStatus,
} from "logic/src/objects/session/type";
import { ERichModalFileParseStatus } from "logic/src/objects/file/types";
import { ReactComponent as FolderIcon } from "logic/src/components/icons/folder.svg";
import { ReactComponent as CloseIcon } from "logic/src/components/icons/cross.svg";
import { ReactComponent as WarningIcon } from "logic/src/components/icons/confirmWarning.svg";
import FileWidget from "../FileWidget";
import LinkFileWidget from "../LinkFileWidget";

import styles from "./index.module.scss";

interface IProps {
  fileList?: ISessionFile[];
  previewFileId?: string;
  onPreviewFile: (file_id: string) => void;
  onDirFileDelete: (file_id: string) => void;
}

const ConfirmTitle = () => (
  <p className={styles.confirmContent}>
    <WarningIcon />
    <span>是否要删除资料？删除后不可恢复</span>
  </p>
);

const ChatFileFolder: React.FC<IProps> = ({
  fileList,
  previewFileId,
  onPreviewFile,
  onDirFileDelete,
}) => {
  const [modal, contextHolder] = Modal.useModal();
  const [folderVisible, setFolderVisible] = useState(false);
  const folderRef = useRef<any>(null);
  const folderIconRef = useRef<any>(null);
  useClickAway(() => setFolderVisible(false), [folderRef, folderIconRef]);

  const hasDirFile = !!fileList?.length;
  const isFolderAble = fileList?.some(
    ele => ele.type !== ESessionFileType.image,
  );

  const handleDirFileClick = (file_id?: string) => {
    if (!file_id) return;
    onPreviewFile(file_id);
    setFolderVisible(false);
  };

  const handleDirFileDelete = (file_id?: string) => {
    if (!file_id) return;
    modal.confirm({
      icon: null,
      className: styles.confirmContent,
      title: <ConfirmTitle />,
      okText: "删除",
      cancelText: "取消",
      cancelButtonProps: {
        type: "primary",
        className: styles.confirmCancelBtn,
      },
      okButtonProps: {
        type: "default",
        className: styles.confirmOkBtn,
      },
      onOk: () => {
        onDirFileDelete(file_id);
      },
    });
  };

  const FolderContent = (
    <div className={styles.folderContainer} ref={folderRef}>
      <div className={styles.top}>
        <div className={styles.titleWrap}>
          <span>资料夹</span>
          <CloseIcon
            className={styles.closeIcon}
            onClick={() => setFolderVisible(false)}
          />
        </div>
        <p className={styles.desc}>我来陪你阅读所有已上传资料～</p>
      </div>
      <div className={styles.center}>
        {fileList?.map(fileEle => {
          if (fileEle.type === ESessionFileType.file) {
            return (
              <div className={styles.fileItem}>
                <FileWidget
                  name={fileEle.file_name}
                  onNameClick={() => handleDirFileClick(fileEle.file_id)}
                  onDelete={
                    previewFileId !== fileEle.file_id
                      ? () => handleDirFileDelete(fileEle.file_id)
                      : undefined
                  }
                />
              </div>
            );
          }
          // if (fileEle.type === ESessionFileType.image) {
          //   return (
          //     <div className={styles.imgFileItem}>
          //       <ImageWidget
          //         url={fileEle.url}
          //         onDelete={() => handleDirFileDelete(fileEle.file_id)}
          //         onPreview={() => handleDirFileClick(fileEle.file_id)}
          //       />
          //     </div>
          //   );
          // }
          if (fileEle.type === ESessionFileType.link) {
            return (
              <div className={styles.fileItem}>
                <LinkFileWidget
                  file={fileEle}
                  // onClick={() => handleDirFileClick(fileEle.file_id)}
                  onClick={() => window.open(fileEle.file_name, "_blank")}
                  onDelete={
                    fileEle.status === ERichModalFileParseStatus.running ||
                    previewFileId === fileEle.file_id ||
                    [
                      ESessionFileContentParseStatus.pending,
                      ESessionFileContentParseStatus.parsing,
                    ].includes(fileEle.contentParseStatus)
                      ? undefined
                      : () => {
                          handleDirFileDelete(fileEle.file_id);
                        }
                  }
                />
              </div>
            );
          }
        })}
      </div>
      <div className={styles.bottom}>可以继续上传资料给我哦～</div>
    </div>
  );

  return (
    <>
      <Popover
        trigger="click"
        title={false}
        arrow={false}
        overlayInnerStyle={{
          padding: 0,
        }}
        open={folderVisible}
        onOpenChange={hasDirFile ? () => setFolderVisible(true) : () => {}}
        content={FolderContent}
      >
        <Tooltip
          placement="top"
          trigger={["hover", "click"]}
          color="#242424"
          title="资料夹"
        >
          <FolderIcon
            className={cls(styles.folderIcon, {
              [styles.emptyFolder]: !isFolderAble,
              [styles.visibleFolder]: folderVisible,
            })}
            ref={folderIconRef}
          />
        </Tooltip>
      </Popover>
      {contextHolder}
    </>
  );
};
export default observer(ChatFileFolder);
